export default __webpack_public_path__ + "static/media/48t.91fafe1a.jpg";